import React, { useEffect, useState } from 'react';

const TrainingMenu = () => {
    const menuItems = [
        { id: 'about', label: 'About' },
        { id: 'videos', label: 'Videos' },
        { id: 'topics', label: 'Topics' },
        { id: 'testimonial', label: 'Testimonial' },
    ];

    const scrollToSection = (id) => {
        const element = document.getElementById(id);
        if (element) {
            element.scrollIntoView({ behavior: 'smooth' });
        }
    };

    // Responsive gap based on screen width
    const [gap, setGap] = useState('60px');

    useEffect(() => {
        const handleResize = () => {
            const width = window.innerWidth;
            if (width < 480) setGap('20px');
            else if (width < 768) setGap('30px');
            else setGap('60px');
        };

        handleResize(); // Initial check
        window.addEventListener('resize', handleResize);

        return () => window.removeEventListener('resize', handleResize);
    }, []);

    const ulStyle = {
        listStyle: 'none',
        padding: 0,
        margin: 0,
        display: 'flex',
        flexWrap: 'wrap',
        justifyContent: 'center',
        gap: gap,
    };

    const buttonStyle = {
        background: 'none',
        border: 'none',
        padding: '10px 15px',
        cursor: 'pointer',
        color: 'inherit',
        fontSize: '16px',
        fontWeight: '500',
        borderRadius: '6px',
        transition: 'background 0.3s',
    };

    const buttonHoverStyle = {
        background: 'rgba(0,0,0,0.1)',
    };

    return (
        <ul style={ulStyle}>
            {menuItems.map((item) => (
                <li key={item.id}>
                    <button
                        onClick={() => scrollToSection(item.id)}
                        onMouseEnter={(e) => (e.currentTarget.style.background = 'rgba(0,0,0,0.1)')}
                        onMouseLeave={(e) => (e.currentTarget.style.background = 'none')}
                        style={buttonStyle}
                    >
                        {item.label}
                    </button>
                </li>
            ))}
        </ul>
    );
};

export default TrainingMenu;
